import React from 'react';
import ContactCard from '../../contact-card/ContactCard';
import { SearchResultContext } from '../context/SearchResultContext';
import Select from '../../select/Select';
import NoResults from './NoResults';

const Contacts = (props) => {

    const { results, sortOrder, setSortOrder } = React.useContext(SearchResultContext);

    if (results.items.length <= 0) return <NoResults heading={props.noResultsHeading} preamble={props.noResultsPreamble} query={props.query} />;

    return (
        <div className='search-result-block'>

            <div className='h-display-flex h-justify-content-end'>
                <Select label={`${props.sortByLabel}`} options={props.sortOptions.map(i => ({ value: i.sortOrder, label: i.displayName }))} value={sortOrder} onChange={(e) => {
                    setSortOrder(e.target.value);
                }} />
            </div>
            <div className='search-result-contact'>
                {results.items.map((item) => {
                    if (!item.searchHitObject) return null;
                    return ContactCard(item, props.showLessLabel, props.showMoreLabel);
                })}

            </div >
        </div>
    );
};

export default Contacts;
